import {BaseMuWidget} from "./BaseMuWidget";
import {CalendarItem} from "./CommonTypes";
import {DmsCL} from "./generated/DmsCL";
import {CalCL} from "./generated/CalCL";
import {TicketsCL} from "./generated/TicketsCL";
import {PqmCL} from "./generated/PqmCL";
import {DateRepeating} from "./components/DateRepeating";

export class UiCalendarItemDetail extends BaseMuWidget {
    protected calCl = new CalCL();
    protected ticketsCl = new TicketsCL();
    protected pqmCl = new PqmCL();
    beforeIndex() {
        this.muAppendContent(`
            <h4><span mu-bind="note"></span> <span class="head-subtitle" mu-bind="typeLabel"></span></h4>
            <div>
                <span mu-bind='dtFrom|dateTime("auto-date-time")'></span> -
                <span mu-bind='dtTo|dateTime("auto-date-time")'></span>
            </div>
            <div mu="pProcData">
                <a mu="lProcData">Spuštěný proces <span mu-bind="procDataSummary"></span> <em mu-id="procDataEvidenceUid" mu-bind="procDataEvidenceUid"></em></a>
                <h5>Související požadavky</h5>
                <ul mu-bind="tickets:@foreach">
                    <li mu=":UiCalendarItemDetailTicketLI@item">
                        <a mu="link">
                            <strong mu-bind="evidenceUid"></strong> <span mu-bind="summary"></span>
                        </a>
                    </li>
                </ul>
            </div>
            <div mu="repeatingInfo"></div>
            <div>
                <a mu="ticketLink">
                    Patří k požadavku 
                    <strong mu-bind='ticket|getField("evidenceUid")'></strong>
                    <strong mu-bind='ticket|getField("summary")'></strong>
                </a>
            </div>
        `);
    }

    closeDetail(ev: Event | string) {
        this.muRemoveSelf();
    }

    public async bindData(item: CalendarItem) {
        let typeLabel = "";
        if (item.repeat) typeLabel = "Opakovaná položka";
        else if (item.procDataId) typeLabel = "Datum procesu";
        else typeLabel = "Položka kalendáře" + (item.calItemRepeating ? " z opakování" : "");

        this.muBindData({
            ...item,
            typeLabel
        });
        this.muVisible(false, [ 'pProcData' ]);

        if (item.procDataId) {
            this.muVisible(true, 'pProcData');
            this.muBindData(await this.pqmCl.getMyTicketWithPqmPacket(
                item.procDataId,
                item.pqmPacketId!,
            ));
            this.getRouter().paProcData(this.ui.lProcData, item.procDataId);
        }

        if (item.calItemRepeating) {
            this.ui.repeatingInfo.innerText = DateRepeating.getTextInfo(item.calItemRepeating);
        }

        if (item.ticket) {
            this.getRouter().paTicket(this.ui.ticketLink, item.ticket);
        } else this.muVisible(false, 'ticketLink');
    }

    ticketLink_click(ev: Event) {
        this.closeDetail(ev);
    }
}

export class UiCalendarItemDetailTicketLI extends BaseMuWidget {
    protected muAfterBindData(data: any) {
        this.getRouter().paTicket(this.ui.link, data);
    }
    link_click(ev) {
       this.callMethodInFirstAncestors('closeDetail', ev);
    }
}